module.exports = __webpack_public_path__ + "img/application1.b1c64c85.png";